import type { PulseEvent } from '../pulseSchema';

/** Pulse sends null GA4 ids — client-side gtag lookup removed per product requirement. */
export const attachGa4IdsToEvents = (events: PulseEvent[]): PulseEvent[] => {
  if (!events.length) return events;
  return events.map((event) => ({
    ...event,
    client_id: null,
    session_id: null,
  }));
};
